<div class="rpc-progress">

    <div class="rpc-progress-thumb">
    </div>

</div>